/* @flow */

import * as types from 'src/shared/app/preference/action/preferenceActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
|------------------------------------------------------------------------------
| INITIAL STATE
|------------------------------------------------------------------------------
*/

const initialState = {
  isChangePasswordShown: false,
  isDeleteAccountShown: false,
};

/*
|------------------------------------------------------------------------------
| REDUCERS
|------------------------------------------------------------------------------
*/

const _toggleChangePassword = (state: Object): Object => ({
  ...state,
  isChangePasswordShown: !state.isChangePasswordShown,
});

const _toggleDeleteAccount = (state: Object): Object => ({
  ...state,
  isDeleteAccountShown: !state.isDeleteAccountShown,
});

/*
|------------------------------------------------------------------------------
| REDUCER
|------------------------------------------------------------------------------
*/

export default createReducer(initialState, {
  [types.TOGGLE_CHANGE_PASSWORD]: _toggleChangePassword,
  [types.TOGGLE_DELETE_ACCOUNT]: _toggleDeleteAccount,
});
